@if (error()) {
  <div class="flex-column place-center error-container">
    <fa-icon
      icon="triangle-exclamation"
      class="margin-bottom-regular"
      size="6x"
    ></fa-icon>
    @switch (error()) {
      @case ("not_found") {
        <h1 i18n>Public Form not found</h1>
        <p i18n>
          The form you are looking for is either unavailable or doesn't exist.
          Please check the link and try again.
        </p>
      }
      @case ("no_permissions") {
        <h1 i18n>No access to public form "{{ formConfig()?.title }}"</h1>
        <p i18n>
          Unfortunately, you do not have the required permissions to submit data
          through this form. Please contact the person who shared this link with
          you. In case you have a user account, please make sure you are logged
          in.
        </p>
      }
    }
  </div>
} @else {
  <mat-card>
    <mat-card-header>
      <div class="card-container">
        <mat-card-title>{{ formConfig()?.title }}</mat-card-title>
        <div class="public-form-container">
          @if (formConfig()?.logo) {
            <app-display-img
              [entity]="formConfig()"
              imgProperty="logo"
              class="public-form-image"
            ></app-display-img>
          }
        </div>
        @if (formConfig()?.description) {
          <!-- needs the @if wrapper because <markdown> doesn't seem to do good change detection -->
          <mat-card-subtitle>
            <markdown>{{ formConfig()?.description }}</markdown>
          </mat-card-subtitle>
        }
      </div>
    </mat-card-header>

    @if (formConfig()) {
      <mat-card-content>
        @for (entry of entityFormEntries(); track $index) {
          <app-entity-form
            [entity]="entry.entity"
            [fieldGroups]="entry.fieldGroups"
            [form]="entry.form"
            [gridLayout]="false"
          ></app-entity-form>
        }
      </mat-card-content>

      <mat-card-footer>
        @if (validationError()) {
          <div
            class="flex-column align-start margin-bottom-regular invalid-fields-container"
            role="alert"
          >
            <div class="color-error" i18n>
              Some fields are invalid, please check the form and submit again:
            </div>

            @if (invalidFieldNames.length > 0) {
              <ul class="color-error invalid-fields-list">
                @for (fieldName of invalidFieldNames(); track fieldName) {
                  <li>{{ fieldName }}</li>
                }
              </ul>
            }
          </div>
        }
        <button
          mat-raised-button
          (click)="submit()"
          color="accent"
          i18n="Submit form button"
        >
          Submit Form
        </button>
        <button mat-stroked-button (click)="reset()" i18n="Reset form button">
          Reset
        </button>
      </mat-card-footer>
    } @else {
      <mat-card-content>
        <p i18n>Loading form ...</p>
      </mat-card-content>
    }
  </mat-card>
}
